export default __webpack_public_path__ + "static/media/secure-warning1.3c7646fb.png";